import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-image: url( ${process.env.REACT_APP_APP_URL + 'images/footer.svg'} );
  background-size: auto;
  background-position-x: -6rem;
  height: 256px;

  @media screen and (max-width: 768px) {
    height: 120px;
    background-size: calc(100vw + 36rem);
  }
`;

export const Footer = () => {
  return (
    <FooterContainer />
  )
}
